import { setError } from 'aem-libs-react-ts/src/store/Store'
import { regularInvestmentService } from 'aem-libs-regular-investment/src/services'
import {
  IRegInvestAmountRequest,
  IRegInvestAmountResponse,
  IRegInvestSavingsRequest,
  IRegInvestSavingsResponse,
} from 'aem-libs-regular-investment/src/services/types'

import { IInputAmountValues, IInputSavingsValues } from '../model'
import { CalcType } from '../model/enums'
import { IRegInvestStore } from '../store/createStore'
import {
  INIT_AMOUNT,
  INIT_SAVINGS,
  SET_AMOUNT_INPUTS,
  SET_AMOUNT_RESULT,
  SET_CALC_TAB,
  SET_EXTRA_DEPOSIT,
  SET_SAVINGS_INPUTS,
  SET_SAVINGS_RESULT,
} from './actionTypes'

export const initAmountCalc = (
  inputs: IInputAmountValues,
  result: IRegInvestAmountResponse,
) => {
  return {
    type: INIT_AMOUNT,
    inputs,
    result,
  }
}

export const initSavingsCalc = (
  inputs: IInputSavingsValues,
  result: IRegInvestSavingsResponse,
) => {
  return {
    type: INIT_SAVINGS,
    inputs,
    result,
  }
}

export const setCalcTab = (calcType: CalcType) => {
  return {
    type: SET_CALC_TAB,
    calcType,
  }
}

export const setAmountInputs = (inputs: IInputAmountValues) => {
  return {
    type: SET_AMOUNT_INPUTS,
    inputs,
  }
}

export const setAmountResult = (result: IRegInvestAmountResponse) => {
  return {
    type: SET_AMOUNT_RESULT,
    result,
  }
}

export const setSavingsInputs = (inputs: IInputSavingsValues) => {
  return {
    type: SET_SAVINGS_INPUTS,
    inputs,
  }
}

export const setSavingsResult = (result: IRegInvestSavingsResponse) => {
  return {
    type: SET_SAVINGS_RESULT,
    result,
  }
}

export const setExtraDeposit = (hasExtraDeposit: boolean) => {
  return {
    type: SET_EXTRA_DEPOSIT,
    hasExtraDeposit,
  }
}

export const calculateAmount = (
  inputs: IInputAmountValues,
  hasDeposit: boolean,
) => (dispatch: any, getState: () => IRegInvestStore) => {
  const { appSpinner, paramsFile, userTracking } = getState().context

  dispatch(setAmountInputs(inputs))
  appSpinner.show()
  userTracking.onRequest(inputs)

  let deposit = inputs.deposit
  if (!hasDeposit) {
    deposit = 0
  }

  const request: IRegInvestAmountRequest = {
    investorType: inputs.investorType,
    targetAmount: inputs.amount,
    yearCount: inputs.duration,
    initDeposit: deposit,
  }

  return regularInvestmentService
    .calcAmount(paramsFile, request)
    .then((response) => {
      userTracking.onResponse(response.data)
      dispatch(setAmountResult(response.data))
    })
    .catch(() => dispatch(setError(true)))
    .finally(() => appSpinner.hide())
}

export const calculateSavings = (inputs: IInputSavingsValues) => (
  dispatch: any,
  getState: () => IRegInvestStore,
) => {
  const { appSpinner, paramsFile, userTracking } = getState().context

  dispatch(setSavingsInputs(inputs))
  appSpinner.show()
  userTracking.onRequest(inputs)

  const request: IRegInvestSavingsRequest = {
    investorType: inputs.investorType,
    monthlySavings: inputs.amount,
    yearCount: inputs.duration,
    initDeposit: 0,
  }

  return regularInvestmentService
    .calcSavings(paramsFile, request)
    .then((response) => {
      userTracking.onResponse(response.data)
      dispatch(setSavingsResult(response.data))
    })
    .catch(() => dispatch(setError(true)))
    .finally(() => appSpinner.hide())
}
